import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  loginSetFlowStageWatcher,
  signupWatcher,
} from "../../redux/actions/loginactioncreators";
import { NewFADVLoginForm } from "./NewFADVLoginForm";
import { EmailEntry } from "./EmailEntry";
import { SafeFormattedMessage } from "./SafeFormattedMessage";

export const SignupNoEmailForm = () => {
  const dispatch = useDispatch();
  const [hasBeenSubmitted, setHasBeenSubmitted] = React.useState(false);
  const signupState = useSelector(state => state.loginForm.signup ?? {});
  const signupMessage = signupState.message ?? "";
  const username = signupState.username;
  const password = signupState.password;
  const accountNumber = signupState.accountNumber;

  const handleSubmit = (formData, errors) => {
    setHasBeenSubmitted(true);
    if (errors && Object.keys(errors).length > 0) {
      return;
    }
    const { email } = formData;
    dispatch(signupWatcher({ email, username, password, accountNumber, newEmailRequired: true }));
  };

  const handleCancel = () => {
    setHasBeenSubmitted(false);
    dispatch(loginSetFlowStageWatcher({ flowStage: "LOGIN" }));
  };

  const showErrors = hasBeenSubmitted;

  return (
    <NewFADVLoginForm
      onSubmit={handleSubmit}
      showErrors={showErrors}
      requiredFields={["email"]}
      headerContent={<FormattedMessage id="signup.noEmailHeader" defaultMessage="Enter Your Email" description="Header for the signup no-email form" />}
      submitButtonText={<FormattedMessage id="signup.checkEmail" defaultMessage="Continue" description="Button text for submitting email in signup no-email form" />}
      onEscapeKey={handleCancel}
      middleContent={(
        <div className="flex flex-col justify-center items-center">
          <button
            type="button"
            id="returnToSignIn"
            className="w-full bg-white hover:bg-gray-50 text-gray-700 font-medium py-2 px-4 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg transition-colors duration-200"
            onClick={handleCancel}
          >
            <FormattedMessage id="signup.returnToSignIn" defaultMessage="Return to Sign In" description="Button text to return user from sign-up flow to login form" />
          </button>
        </div>
      )}
    >
      <p className="text-primary-fg text-base leading-6">
        <FormattedMessage
          id="signup.noEmailBlurb"
          defaultMessage="Your account doesn't have an email address on file. Please enter a valid email to continue. We'll use this to verify your identity and secure your account."
          description="Instructional text shown when signup finds no email for the user"
        />
      </p>
      {signupMessage && (
        <div className="bg-blue-50 w-full border border-blue-200 text-blue-700 text-base px-5 py-4 rounded" role="status" aria-live="polite">
          {typeof signupMessage === "object" && signupMessage.id ? <SafeFormattedMessage {...signupMessage} /> : signupMessage}
        </div>
      )}
      <EmailEntry
        id="email"
        name="signupEmail"
        autoFocus={true}
      />
    </NewFADVLoginForm>
  );
};
